import React, { useState, useEffect } from "react";
import { Button, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { collection, addDoc, doc, getDoc } from "firebase/firestore";
import { firestore } from "config/firebase";
import ProductCard from "./ProductCard";
import { useAuthContext } from "contexts/AuthContext";

const ReviewCheckList = ({ prev }) => {
  const { user } = useAuthContext();
  const [cartData, setCartData] = useState([]);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch cart data and user details
    const fetchData = async () => {
      try {
        // Replace with actual fetch logic
        const cartSnapshot = await getDoc(doc(firestore, "carts", user.uid));
        const userSnapshot = await getDoc(doc(firestore, "users", user.uid));

        if (cartSnapshot.exists()) {
          setCartData(cartSnapshot.data().selectedProducts || []);
        }

        if (userSnapshot.exists()) {
          const userData = userSnapshot.data();
          setShippingAddress(userData.address || null);
          setPaymentMethod(userData.paymentMethod || null);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        message.error("Failed to fetch data.");
      }
    };

    fetchData();
  }, [user.uid]);

  const handleEditAddress = () => {
    // Navigate to address editing page
    console.log("Edit address clicked");
  };

  const handleEditPayment = () => {
    // Navigate to payment method editing page
    console.log("Edit payment clicked");
  };

  const handlePlaceOrder = async () => {
    setLoading(true);
    try {
      if (!user || !cartData.length || !shippingAddress || !paymentMethod) {
        throw new Error("Missing necessary information.");
      }

      const orderData = {
        userId: user.uid,
        cart: cartData,
        address: shippingAddress,
        paymentMethod,
        status: "Pending",
        createdAt: new Date(),
      };

      // Save order data to Firestore
      await addDoc(collection(firestore, "orders"), orderData);
      message.success("Order placed successfully!");

      // Redirect or show confirmation
      // e.g., redirect to a confirmation page
    } catch (error) {
      console.error("Error placing order:", error);
      message.error("Failed to place order. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      <div style={{ marginBottom: "24px" }}>
        <h4 style={{ fontWeight: "600", marginBottom: "8px" }}>
          Estimated delivery: {new Date().toLocaleDateString()}
        </h4>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            marginTop: "20px",
          }}
        >
          {cartData?.map((product, index) => (
            <ProductCard key={index} data={product} />
          ))}
        </div>
      </div>

      <div className="address-section" style={{ marginBottom: "24px" }}>
        <h4 style={{ fontWeight: "600" }}>Shipping Address</h4>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: '24px'
          }}
        >
          {shippingAddress ? (
            <div>
              <h5>{shippingAddress.name}</h5>
              <p>
                {`${shippingAddress.addressLine1}, ${shippingAddress.addressLine2}, ${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.pinCode}`}
              </p>
              <Button
                style={{ backgroundColor: "#f8f8f8", borderRadius: "14px" }}
                size="large"
                icon={<EditOutlined />}
                onClick={handleEditAddress}
              />
            </div>
          ) : (
            <p>No address found. Please add a new address.</p>
          )}
        </div>
        <hr />
      </div>

      <div className="payment-section" style={{ marginBottom: "24px" }}>
        <h4 style={{ fontWeight: "600" }}>Payment Method</h4>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: '24px'
          }}
        >
          {paymentMethod ? (
            <h6>{paymentMethod.type} (.... .... .... {paymentMethod.lastFourDigits})</h6>
          ) : (
            <p>No payment method found. Please add a new payment method.</p>
          )}
          <Button
            style={{ backgroundColor: "#f8f8f8", borderRadius: "14px" }}
            size="large"
            icon={<EditOutlined />}
            onClick={handleEditPayment}
          />
        </div>
        <hr />
      </div>

      <div className="mt-5">
        <Button
          type="primary"
          style={{ width: "100%", padding: "24px 112px" }}
          onClick={handlePlaceOrder}
          loading={loading}
        >
          Place Order
        </Button>
        <Button
          style={{ padding: "24px 112px", marginTop: "24px", width: "100%" }}
          onClick={() => prev()}
        >
          Go Back
        </Button>
      </div>
    </div>
  );
};

export default ReviewCheckList;
